const SITE_ORIGIN = 'https://miamisoundrental.com'

const item = (name, path) => ({
  name,
  url: `${SITE_ORIGIN}${path === '/' ? '' : path}`
})

const VISUAL_FAMILY_BREADCRUMBS = {
  '/visuals': [
    item('Home', '/'),
    item('Visual Equipment Rental', '/visuals')
  ],
  '/led-video-wall-rental': [
    item('Home', '/'),
    item('Visual Equipment Rental', '/visuals'),
    item('LED Video Wall Rental', '/led-video-wall-rental')
  ],
  '/orlando/led-video-wall-rental': [
    item('Home', '/'),
    item('Orlando AV Rental', '/orlando'),
    item('Orlando LED Video Wall Rental', '/orlando/led-video-wall-rental')
  ],
  '/orlando/tv-rental': [
    item('Home', '/'),
    item('Orlando AV Rental', '/orlando'),
    item('Orlando TV Rental', '/orlando/tv-rental')
  ],
  '/orlando/projector-rental': [
    item('Home', '/'),
    item('Orlando AV Rental', '/orlando'),
    item('Orlando Projector Rental', '/orlando/projector-rental')
  ],
  '/projector-rental': [
    item('Home', '/'),
    item('Visual Equipment Rental', '/visuals'),
    item('Projector Rental', '/projector-rental')
  ],
  '/tv-rental': [
    item('Home', '/'),
    item('Visual Equipment Rental', '/visuals'),
    item('TV Rental', '/tv-rental')
  ]
}

export const getVisualFamilyBreadcrumbs = path => (
  (VISUAL_FAMILY_BREADCRUMBS[path] || []).map(breadcrumb => ({ ...breadcrumb }))
)

export const toHeroBreadcrumbs = breadcrumbs => (breadcrumbs || []).map((breadcrumb, index, list) => ({
  label: breadcrumb.name,
  href: index === list.length - 1
    ? undefined
    : breadcrumb.url.replace(SITE_ORIGIN, '') || '/'
}))

export const toBreadcrumbJsonLdItems = breadcrumbs => (breadcrumbs || []).map((breadcrumb, index) => ({
  position: index + 1,
  name: breadcrumb.name,
  item: breadcrumb.url
}))

export default VISUAL_FAMILY_BREADCRUMBS
